import React, { useEffect, useState } from 'react';
import { change_alias, handleApi } from 'helper/helper';
import { getWards } from 'api/api';
import { trans } from 'config/LinguiConfig';
import { t } from '@lingui/macro';
import CustomSelect from 'MUI_Kit/components/CustomSelect/CustomSelect';

const SelectWard = ({ value, onChange, district }) => {
  const [data, setData] = useState([]);

  const fetchData = async () => {
    let { data } = await handleApi(getWards(district));
    if (data) setData(data.map((item) => ({ key: item.id, value: item.name })));
  };

  const filterData = (keyword) => {
    return data.filter((item) => change_alias(item.value).includes(change_alias(keyword)));
  };

  useEffect(() => {
    if (district) fetchData();
  }, []);

  return (
    <CustomSelect
      label={t`Phường/Xã`}
      data={data}
      disabled={data.length === 0}
      value={value || ''}
      onChange={onChange('ward')}
      filterData={filterData}
    />
  );
};

export default SelectWard;
